var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.total > 0)?_c('div',{staticClass:"std-pagination"},[_c('Pagination',{attrs:{"layout":_vm.layout,"sizes":_vm.sizes,"align":"right","small":""},on:{"change":_vm.emitChange},model:{value:(_vm.inner),callback:function ($$v) {_vm.inner=$$v},expression:"inner"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }